import React from 'react';

import { Text, TextType } from 'ui-components/components/text';
import { FlexRow } from 'ui-components/components/flex';
import { MessageDescriptorPropType } from '../../../prop-types/intl';
import { useSetupContext } from '../context';

import messages from '../messages';
import style from './title.module.less';

export const SetupTitle = ({ titleDescriptor, subtitleDescriptor = null }) => {
  const { currentStepNumber, totalNumberOfSteps } = useSetupContext();
  return (
    <div className={style['title-container']}>
      <FlexRow className={style['title-and-step-container']}>
        <Text className={style['setup-title']} textType={TextType.H2} value={titleDescriptor} />
        <Text
          className={style['step-number']}
          formattedMessageValues={{
            currentStepNumber,
            totalNumberOfSteps,
          }}
          textType={TextType.Description}
          value={messages.stepNumber}
        />
      </FlexRow>
      {!!subtitleDescriptor && <Text textType={TextType.Description} value={subtitleDescriptor} />}
    </div>
  );
};

SetupTitle.propTypes = {
  titleDescriptor: MessageDescriptorPropType.isRequired,
  subtitleDescriptor: MessageDescriptorPropType,
};
